// As configurações da loja (tenant_settings, JSONB por seção): uma leitura,
// várias telas. Salvar é por seção; o tema responde os avisos pelo cabeçalho
// X-Tema-Avisos.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useLoja } from '../estado/loja';
import { api } from './api';

export interface Configuracoes { ok: boolean; data: Record<string, unknown> }

const base = () => `/api/tenant/${encodeURIComponent(useLoja.getState().tenantId ?? '')}`;
export const chaveDasConfiguracoes = (tenantId: string) => ['configuracoes', tenantId] as const;

export function useConfiguracoes() {
  const tenantId = useLoja((s) => s.tenantId) ?? '';
  return useQuery({ queryKey: chaveDasConfiguracoes(tenantId), queryFn: () => api.get<Configuracoes>(`${base()}/settings`), enabled: tenantId !== '' });
}

/** Uma seção das configurações, como objeto (ou vazio). */
export function secao<T extends object>(c: Configuracoes | undefined, nome: string): Partial<T> {
  const v = c?.data?.[nome];
  return (v && typeof v === 'object' ? v : {}) as Partial<T>;
}

export async function salvarSecao(section: string, payload: unknown): Promise<{ avisos: number }> {
  const r = await api.postComCabecalhos<{ ok: boolean }>(`${base()}/settings`, { section, payload });
  return { avisos: Number(r.cabecalhos.get('X-Tema-Avisos') || 0) };
}

export function useSalvarSecao() {
  const consultas = useQueryClient();
  const tenantId = useLoja((s) => s.tenantId) ?? '';
  return useMutation({
    mutationFn: ({ section, payload }: { section: string; payload: unknown }) => salvarSecao(section, payload),
    onSuccess: () => consultas.invalidateQueries({ queryKey: chaveDasConfiguracoes(tenantId) }),
  });
}
